var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"rounded-md py-1 px-2 text-sm",style:(`background-color:${_vm.backgroundColor};color:${_vm.textColor};`)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }